// ResponsiveEntites.jsx → src/gestion-entites/
// Un seul wrapper pour les deux onglets : `entityType` choisit l'écran desktop
// correspondant, l'écran mobile étant déjà paramétré par ce même type.
import React from "react";
import GestionEntitieClient from "./Gestion.entitie_client";
import GestionEntitieFournisseur from "./Gestion.entitie_fournisseur";
import EntitesMobile from "../mobile/entites/EntitesMobile";
import useIsMobile from "../hooks/useIsMobile";

export default function ResponsiveEntites({ entityType = "customer", ...props }) {
  const isMobile = useIsMobile();

  if (isMobile) return <EntitesMobile entityType={entityType} {...props} />;

  return entityType === "supplier" ? (
    <GestionEntitieFournisseur {...props} />
  ) : (
    <GestionEntitieClient {...props} />
  );
}
